<template>
  <div
    v-if="!isMateridouska && (displayedArticles.length > 0 || isLoading)"
    class="section__articles-container"
  >
    <div>
      <component
        v-if="title && (displayedArticles.length > 0 || isLoading)"
        class="h4"
        :is="headingElement"
      >
        {{ title }}
      </component>
    </div>
    <div
      v-for="(article, index) in displayedArticles"
      :key="`external_article_${article.id}`"
      class="article-wrapper"
    >
      <DefaultArticlesArticleCard
        :article="article"
        :data-index="index"
        :type="ArticleComponentType.RECOMMENDED"
        :hide-author="hideAuthor"
        :hide-magazine="hideMagazine"
        :show-magazine-name="showMagazineName"
      />
    </div>

    <!-- Loading skeleton -->
    <div
      v-if="isLoading"
      v-for="item in articlesCount"
      :key="`external_skeleton_${item}`"
      class="article-wrapper"
    >
      <DefaultSkeletonsArticleCard :type="ArticleComponentType.RECOMMENDED" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ArticleComponentType from '~/libs/constants/ArticleComponentType'
import { TemplateList } from '~/libs/constants/TemplateList'

const isMateridouska = computed(() => useUniWebTemplate().getTemplateListItem() === TemplateList.MATERIDOUSKA)

const props = withDefaults(
  defineProps<{
    title?: string
    headingElement?: string
    articlesCount?: number
    hideAuthor?: boolean
    hideMagazine?: boolean
    showMagazineName?: boolean
  }>(),
  {
    headingElement: 'h3',
    articlesCount: 5,
    hideAuthor: true,
    hideMagazine: false,
    showMagazineName: true,
  }
)

const { articles, isLoading, fetchArticles } = useExternalArticles()

const displayedArticles = computed(() => {
  const items = articles.value
  return props.articlesCount ? items.slice(0, props.articlesCount) : items
})

onMounted(() => {
  if (!isMateridouska.value) {
    fetchArticles()
  }
})
</script>
